import React from 'react';
import '../assets/css/floating-buttons.css';

export default function SocialBar() {
  const whatsappNumber = '919992699979';
  const whatsappMessage = 'Hello! I would like to know more about Mahawar Sabha.';
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  const phoneNumber = '9992699979';

  return (
    <div className="social-bar" aria-hidden={false}>
      <a
        className="social-link whatsapp"
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        title="WhatsApp"
      >
        <i className="bi bi-whatsapp"></i>
      </a>

      <a
        className="social-link phone"
        href={`tel:${phoneNumber}`}
        aria-label="Phone"
        title="Call us"
      >
        <i className="bi bi-telephone-fill"></i>
      </a>

      <a
        className="social-link facebook"
        href="//www.facebook.com/p/Mahawar-Vaish-Sabha-Rewari-100064901522085/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        title="Facebook"
      >
        <i className="bi bi-facebook"></i>
      </a>
    </div>
  );
}
